export default "__VITE_ASSET__3e666bb3__"